import { render } from "./AdminHomePage.vue?vue&type=template&id=03f5a56c"
import script from "./AdminHomePage.vue?vue&type=script&lang=js"
export * from "./AdminHomePage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__